import Query from '../utils/Query';

const createdBy = 'created_by.id,created_by.screen_name,created_by.first_name,created_by.last_name,created_by.avatar.private_hash,created_by.last_access_on';
const user = 'user.id,user.screen_name,user.first_name,user.last_name,user.avatar.private_hash,user.last_access_on';

export default class FollowingService {

	static countFollowers(id) {
		return Query.get('/items/following?filter[user]=' + id + '&meta=filter_count&limit=0');
	}

	static countFollowing(id) {
		return Query.get('/items/following?filter[created_by]=' + id + '&meta=filter_count&limit=0');
	}

	static isFollowing(currentUserId, id) {
		return Query.get('/items/following?filter[created_by]=' + currentUserId + '&filter[user]=' + id + '&meta=filter_count&limit=0');
	}

	static getFollowings(userId) {
		return Query.get('/items/following?filter[created_by]=' + userId + '&limit=100&meta=filter_count&fields=*,' + user);
	}

	static getFollowers(userId) {
		return Query.get('/items/following?filter[user]=' + userId + '&limit=100&meta=filter_count&fields=*,' + createdBy);
	}

	static toggleFollowing(id) {
		return Query.post('/custom/following/toggle/' + id);
	}
}
